export default "__VITE_ASSET__BPDzKbf5__"